import { createApi } from '@reduxjs/toolkit/query/react';

import { apiGocardlessClientSignups } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { GocardlessClientSignupRow, GocardlessClientSignupsResponse } from '~direct-debits/models';

export const clientSignupsApi = createApi({
  reducerPath: 'directDebitsClientSignupsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiGocardlessClientSignups }),
  tagTypes: ['client-signups'],
  endpoints: (builder) => ({
    getClientSignups: builder.query<GocardlessClientSignupsResponse, Request | void>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'client-signups', id: 'LIST' }],
      transformResponse: (payload) => unwrap<GocardlessClientSignupsResponse>(payload),
    }),
    sendSignupLink: builder.mutation<GocardlessClientSignupRow, number>({
      query: (clientId) => ({ url: `/${clientId}/send`, method: 'POST' }),
      invalidatesTags: [{ type: 'client-signups', id: 'LIST' }],
      transformResponse: (payload) => unwrap<GocardlessClientSignupRow>(payload),
    }),
  }),
});

export const { useGetClientSignupsQuery, useSendSignupLinkMutation } = clientSignupsApi;
